import './VolumeCheck.css';

interface Props {
    enabled: boolean;
    onChecked: () => void;
}

export function VolumeCheck({ enabled, onChecked }: Props) {
    return (
        <div className={`volume-check ${enabled ? 'checked' : ''}`} onClick={onChecked}>
            <div className='checkbox-icon'></div>
        </div>
    );
}
